import urlJoin from 'url-join';
// to match react-router behaviour we never actually want
// urls with leading slashes!
// With leading slash:
// https://some.domain/base/page + /other-page = https://some.domain/other-page (wrong)
// Without leading slash
// https://some.domain/base/page + other-page = https://some.domain/base/other-page (right)
const removeLeadingSlash = (string) => string.replace(/^\//u, '');
function getHrefFromObject(to, history) {
    const { pathname, search = '', hash = '' } = to;
    // if we're not in a react-router environment, no need to modify
    const base = history ? removeLeadingSlash(pathname) : pathname;
    return urlJoin(base, search, hash);
}
export default function getHref(href, to, history) {
    if (href)
        return href;
    if (typeof to === 'string') {
        return getHrefFromObject({ pathname: to }, history);
    }
    if (typeof to === 'object') {
        return getHrefFromObject(to, history);
    }
}
//# sourceMappingURL=getHref.js.map